import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Thumbnail from "@/components/Thumbnail/Thumbnail.vue";
import Popup from "@/components/Popup/Popup.vue";
import {
    HarvestRecordInCalendarDetail,
    ShippingRecordInCalendarDetail,
    WorkRecordInCalendarDetail,
    RecordImage
} from '@/types';
import { LoginUser } from "@/types/Component";
import moment from 'moment';
import WorkRecordModal from '@/assets/common/Modal/WorkRecordModal/WorkRecordModal.vue';

@Component({
    components: {
        Thumbnail,
        Popup,
        WorkRecordModal,
    }
})
export default class CalendarDetailRecord extends Vue {

    @Prop({ default: ""})
    private selectedDate!: string;

    @Prop({ default: ""})
    isFilteredUpdated!: boolean;

    private shippingRecordUrl = '/admin/shipping_records/calendar';
    private workRecordUrl = '/work_records/calendar';
    private harvestRecordUrl = '/harvest_records/calendar'
    private addBtnClicked = false;
    private isShow = false;
    private selectedWorkRecordId ='';
    private mode = '';
    private recordDate = '';

    private shippingRecords: ShippingRecordInCalendarDetail[] = [];
    private scheduleWorkRecords: WorkRecordInCalendarDetail[] = [];
    private actualWorkRecords: WorkRecordInCalendarDetail[] = [];
    private harvestRecords: HarvestRecordInCalendarDetail[] = [];
    private recordImages: RecordImage[] = [];
    private isHarvestPopup = false
    private harvestRecordId = ''

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
    }

    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    mounted() {
        this.$watch('isFilteredUpdated', this.changeDate, { immediate: true });
    }

    public changeDate() {
        if(this.$store.getters.calendarFilter !=null){
        this.recordImages = [];
            if (this.$store.getters.calendarFilter.dispShipping) {
                this.getShippingRecordDetails();
            }
            else{
                this.shippingRecords=[]
            }
            if (this.$store.getters.calendarFilter.dispHarvest) {
                this.getHarvestRecordDetails();
            }
            else{
                this.harvestRecords=[]
            }
                this.getWorkRecordDetails();
            }
            else{
                this.recordImages = [];
                this.getWorkRecordDetails();
                this.getHarvestRecordDetails();
                this.getShippingRecordDetails();
            }
        }

      getHarvestRecordDetails(){
         this.$apiClient.doRequest('get', `${this.harvestRecordUrl}/${this.selectedDate}`).then((ret) => {
             let harvestRecordsDisplayByFilter = ret;
             if (this.$store.getters.calendarFilter) {
                const filterBy = this.$store.getters.calendarFilter;
                harvestRecordsDisplayByFilter = harvestRecordsDisplayByFilter.filter((harvestRecord: any) => {
                  return (
                    (!filterBy.plantingIds || filterBy.plantingIds.includes(harvestRecord.planting?.id)) &&
                    (!filterBy.agriFieldIds || filterBy.agriFieldIds.includes(harvestRecord.agri_field?.id))
                  );
                });
              }
              harvestRecordsDisplayByFilter.forEach((record: HarvestRecordInCalendarDetail) => {
                record.visible_popup = false;
                if(record.image_id) {
                    record.image_id.forEach((imageId: string) => {
                        this.$apiClient.doRequest('get', `/harvest_records/${record.id}/images/${imageId}`).then((ret: RecordImage) => {
                            ret.record_id = record.id;
                            this.recordImages.push(ret);
                        });
                    });
                }
            });
            this.harvestRecords = harvestRecordsDisplayByFilter;
        });
    }

      getShippingRecordDetails(){
        if(this.isAdmin) {
                this.$apiClient.doRequest('get', `${this.shippingRecordUrl}/${this.selectedDate}`).then((ret) => {
            let shippingRecordsDisplayByFilter = ret;
            if (this.$store.getters.calendarFilter) {
                const filterBy = this.$store.getters.calendarFilter;
                shippingRecordsDisplayByFilter = shippingRecordsDisplayByFilter.filter((shippingRecord: any) => {
                  return (
                    (!filterBy.plantingIds || filterBy.plantingIds.includes(shippingRecord.planting?.id)) &&
                    (!filterBy.agriFieldIds || filterBy.agriFieldIds.includes(shippingRecord.agri_field?.id))
                  );
                });
              }
              
              shippingRecordsDisplayByFilter.forEach((record: ShippingRecordInCalendarDetail) => record.visible_popup = false);
                this.shippingRecords = shippingRecordsDisplayByFilter;
            });
        }
    }

    private getWorkRecordDetails() {
        this.$apiClient.doRequest('get', `${this.workRecordUrl}/${this.selectedDate}`).then((ret) => {
           let workRecordsDisplayByFilter = ret;
            if (this.$store.getters.calendarFilter !== null) {
                const filterBy = this.$store.getters.calendarFilter;
                if (filterBy.plantingIds) {
                    workRecordsDisplayByFilter = workRecordsDisplayByFilter.filter((item:any) =>
                    item.planting && filterBy.plantingIds.includes(item.planting.id)
                  );
                }
                if (filterBy.agriFieldIds) {
                    workRecordsDisplayByFilter = workRecordsDisplayByFilter.filter((item:any) =>
                    item.agri_field && filterBy.agriFieldIds.includes(item.agri_field.id)
                  );
                }
                if (filterBy.workItemIds) {
                    workRecordsDisplayByFilter = workRecordsDisplayByFilter.filter((item:any) =>
                    item.workItem && filterBy.workItemIds.includes(item.workItem.id)
                  );
                }
                if (filterBy.workerIds) {
                    workRecordsDisplayByFilter = workRecordsDisplayByFilter.filter((item:any) => {
                    return (
                      (item.workers && item.workers.some((worker:any) => filterBy.workerIds.includes(worker.worker.id)) ||
                        (filterBy.includeNoWorker && (!item.workers || item.workers.length === 0))
                      )
                    );
                  });
                }
                if (filterBy.machineIds) {
                    workRecordsDisplayByFilter = workRecordsDisplayByFilter.filter((item:any) => {
                    return (
                      (item.machines && item.machines.some((machine:any) => filterBy.machineIds.includes(machine.machine.id)) ||
                        (filterBy.includeNoMachine && (!item.machines || item.machines.length === 0))
                      )
                    );
                  });
                }
              }
              workRecordsDisplayByFilter.forEach((record: WorkRecordInCalendarDetail) => {
                record.visible_popup = false;
                if(record.image_id.length) {
                    record.image_id.forEach((imageId: string) => {
                        this.$apiClient.doRequest('get', `/work_records/${record.id}/images/${imageId}`).then((ret: RecordImage) => {
                            ret.record_id = record.id;
                            this.recordImages.push(ret);
                        });
                    });
                }
            });
            workRecordsDisplayByFilter.sort((a: WorkRecordInCalendarDetail, b: WorkRecordInCalendarDetail) => {
                if (a.working_item_name > b.working_item_name) {
                    return 1
                }
                if (a.working_item_name < b.working_item_name) {
                    return -1
                }
                return 0
            })

            if (this.$store.getters.calendarFilter) {
                if (this.$store.getters.calendarFilter.dispWorkActual) {
                    this.actualWorkRecords = workRecordsDisplayByFilter.filter((record: WorkRecordInCalendarDetail) => record.kind === 'ACTUAL');
                } else {
                  this.actualWorkRecords = [];
                }
                if (this.$store.getters.calendarFilter.dispWorkSchedule) {
                  this.scheduleWorkRecords = workRecordsDisplayByFilter.filter((record: WorkRecordInCalendarDetail) => record.kind === 'SCHEDULE');
                } else {
                  this.scheduleWorkRecords = [];
                }
            } else {
                this.actualWorkRecords = ret.filter((record: WorkRecordInCalendarDetail) => record.kind === 'ACTUAL');
                this.scheduleWorkRecords = ret.filter((record: WorkRecordInCalendarDetail) => record.kind === 'SCHEDULE');
            }              
        }).catch((error) => {
            if(error.status === 404) {
                this.scheduleWorkRecords = [];
                this.actualWorkRecords = [];
            }
        });
    }

    private getWorkTime(time: string):string | null {
        return time ? moment(time, 'hh:mm:ss').format("H:mm") : "";
    }

    private getTotalTime(time: number): string {
        if(time % 60 === 0) {
            return Math.floor(time / 60) + "時間";
        } else if(time > 60) {
            return Math.floor(time / 60) + "時間" + Math.floor(time % 60) + "分";
        } else {
            return time + "分";
        }
    }


    private getWorkImages(recordId: string):RecordImage[] {
        return this.recordImages.filter((images:RecordImage) => {
            return images.record_id == recordId;
        });
    }

    private getHarvestImages(recordId: string) {
        return this.recordImages.filter((images:RecordImage) => {
           return images.record_id == recordId;
        });
    }

    private get date(): string{
        return moment(this.selectedDate).format("YYYY年MM月DD日");
    }

    private clickEditBtn(recordId: string, shippingRecordId: string, harvestRecordId: string,editRecordType: 'shipping' | 'work' | 'harvest') {
        switch (editRecordType) {
            case "shipping":
                this.$router.push({
                    path: `/list/shipping`,
                    query :{
                        recordId : recordId,
                        return_to: 'calendar',
                        date: this.selectedDate,
                        isShippingPopup: 'true',
                    },
                });
                break;
            case "work":
                this.$router.push({
                    path: `/list/work`,
                    query :{
                        recordId : recordId,
                        shippingRecordId : shippingRecordId,
                        harvestRecordId : harvestRecordId,
                        return_to: 'calendar',
                        date: this.selectedDate,
                        isWorkRecordPopup: 'true',
                        modeType:'edit'
                    },
                });
                break;
            case "harvest":
                this.$router.push({
                    path: `/list/harvest`,
                    query :{
                        recordId : recordId,
                        return_to: 'calendar',
                        date: this.selectedDate,
                        isHarvestPopup: 'true'
                    },
                });
                break;
        }
    }

    private clickCreateBtn(createRecordType: 'shipping' | 'work' | 'harvest') {
        switch (createRecordType) {
            case "shipping":
                this.$router.push({
                    path: `/list/shipping`,
                    query: {
                        return_to: 'calendar',
                        date: this.selectedDate,
                        isShippingPopup: 'true',
                      }
                  });
                break;
            case "work":
                // this.openWorkRecordModal('',this.selectedDate,'new')
                this.$router.push({
                    path: `/list/work`,
                    query: {
                        return_to: 'calendar',
                        date: this.selectedDate,
                        isWorkRecordPopup: 'true',
                        modeType:'new'
                      }
                  });
                break;
            case "harvest":
                this.$router.push({
                    path: `/list/harvest`,
                    query: {
                        return_to: 'calendar',
                        date: this.selectedDate,
                        isHarvestPopup: 'true'
                      }
                  });
                break;
        }
    }

    private clickDeleteBtn(recordId: string, deleteRecordType: 'shipping' | 'work' | 'harvest') {
        if (!window.confirm(`削除しますか？`)){
            return;
        }

        switch (deleteRecordType) {
            case "shipping":
                this.$apiClient.doRequest('delete',`/admin/shipping_records/${recordId}`).then(() => {
                    this.$toasted.success('削除しました。')
                    this.shippingRecords.some((record:ShippingRecordInCalendarDetail, index:number) => {
                        if(record.id === recordId) this.shippingRecords.splice(index, 1);
                    });
                    this.$emit('deleteRecord', recordId);
                    this.getWorkRecordDetails();
                    this.getHarvestRecordDetails();
                });
                break;
            case "work":
                this.$apiClient.doRequest('delete',`/work_records/${recordId}`).then(() => {
                    this.$toasted.success('削除しました。')
                    this.scheduleWorkRecords.some((record:WorkRecordInCalendarDetail, index:number) => {
                        if(record.id === recordId) this.scheduleWorkRecords.splice(index, 1);
                    });
                    this.actualWorkRecords.some((record:WorkRecordInCalendarDetail, index:number) => {
                        if(record.id === recordId) this.actualWorkRecords.splice(index, 1);
                    });
                    this.$emit('deleteRecord', recordId);
                });
                break;
            case "harvest":
                this.$apiClient.doRequest('delete',`/harvest_records/${recordId}`).then(() => {
                    this.$toasted.success('削除しました。')
                    this.harvestRecords.some((record:HarvestRecordInCalendarDetail, index:number) => {
                        if(record.id === recordId) this.harvestRecords.splice(index, 1);
                    });
                    this.$emit('deleteRecord', recordId);
                    this.getWorkRecordDetails();
                });
                break;
        }
    }

    private clickHarvestDate(recordId:string, date:string) {
        this.$router.push(`/record/harvest/${recordId}?return_to=calendar&date=${date}`, () => {return});
    }

    private closeDetail() {
        this.$emit('closeDetail')
    }

    openWorkRecordModal(id = '', date='',mode='') 
    {
        this.selectedWorkRecordId = id;
        this.mode = mode;
        this.recordDate = date;
        this.isShow = true;
    }
    
    closeWorkRecordModal() {
        this.selectedWorkRecordId = '';
        this.mode = ''
        this.isShow = false;
    }

}